import FullLoader from "components/loader/full-loader";
import { useDiscount } from "contexts/v1/pages/DiscountContext";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { deleteRequest } from "services/api";
import Swal from "sweetalert2";
import DiscountCreate from "./components/create-discount";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import { DiscountCreateProvider } from "contexts/v1/pages/DiscountCreateContext";
import { formatPrice } from "utils/utils";
import { DISCOUNT_TYPES } from "utils/constants";

const DiscountPage = () => {
  const { discounts, Pagination, refetch } = useDiscount();

  const { handleError, handleSuccess, showCanvasHandler } = useCanvasHandler();

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`/discount/${id}`);

        if (response.success) {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Invoice deleted successfully",
          });
          refetch();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Failed to delete invoice",
          });
        }
      }
    });
  };

  const handleCreate = (e) => {
    e.stopPropagation();
    showCanvasHandler(
      "Create Discount",
      <DiscountCreateProvider>
        <DiscountCreate
          onSuccess={() => {
            handleSuccess(true, "Discount created successfully");
            refetch();
          }}
          onError={handleError}
        />
      </DiscountCreateProvider>
    );
  };

  const handleUpdate = (e, data) => {
    e.stopPropagation();
    showCanvasHandler(
      "Update Discount",
      <DiscountCreateProvider>
        <DiscountCreate
          initialData={data}
          onSuccess={() => {
            handleSuccess(true, "Discount updated successfully");
            refetch();
          }}
          onError={handleError}
        />
      </DiscountCreateProvider>
    );
  };

  if (discounts.loading) {
    return <FullLoader />;
  }

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-5">
        <div className="table-container vh-100">
          <div className="search-container mb-3">
            {/* Search input */}
            <SearchInput />

            {/* Create button */}
            <button className="btn btn-primary" onClick={handleCreate}>
              Create
            </button>
          </div>

          {/* Table */}
          <div className="table">
            <table className="table table-hover table-vcenter">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Value</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              {discounts.data.length > 0 ? (
                <tbody>
                  {discounts.data.map((data, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>{index + 1}</td>
                          <td>{data.name}</td>
                          <td>{data.type}</td>
                          <td>
                            {data.type === DISCOUNT_TYPES[0].value
                              ? formatPrice(data.value)
                              : `${data.value}%`}
                          </td>
                          <td className="text-end">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="default"
                                id="dropdownMenuButton1"
                              >
                                Actions
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  href="#"
                                  onClick={(e) => handleUpdate(e, data)}
                                >
                                  Edit
                                </Dropdown.Item>
                                <Dropdown.Item
                                  href="#"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete(data.id);
                                  }}
                                >
                                  Remove
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan="5" className="text-center">
                      No data available
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>

          {/* Pagination */}
          <div className="mt-4">{discounts.data.length > 0 && Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default DiscountPage;

const SearchInput = () => {
  const { handleSearch, filterOptions } = useDiscount();
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
